export type GallerySpan = 'big' | 'wide' | 'tall'

export interface GalleryItem {
  src: string
  caption: string
  /** Optional credit / context line. */
  credit?: string
  /** Mosaic emphasis — controls how much grid space the tile claims. */
  span?: GallerySpan
}

const base = import.meta.env.BASE_URL

/** Real Uliunai SMP screenshots (shaders on). */
export const gallery: GalleryItem[] = [
  { src: `${base}gallery/shot-01.webp`, caption: 'Lanterns over the torii village', span: 'big' },
  { src: `${base}gallery/shot-02.webp`, caption: 'The cliffside stronghold' },
  { src: `${base}gallery/shot-03.webp`, caption: 'Desert outpost from above' },
  { src: `${base}gallery/shot-04.webp`, caption: 'Malachai the Arcane awaits', credit: 'World boss', span: 'wide' },
  { src: `${base}gallery/shot-05.webp`, caption: 'First light over the highlands' },
  { src: `${base}gallery/shot-06.webp`, caption: 'Beacon above the autumn canopy', span: 'tall' },
  { src: `${base}gallery/shot-07.webp`, caption: 'Festival lights in the ravine' },
  { src: `${base}gallery/shot-08.webp`, caption: 'Trading post on the green hills' },
  { src: `${base}gallery/shot-09.webp`, caption: 'The lonely watchtower', span: 'wide' },
  { src: `${base}gallery/shot-10.webp`, caption: 'Pinewood lake at the foot of the mountains' },
  { src: `${base}gallery/shot-11.webp`, caption: 'Where the pines meet the sea' },
  { src: `${base}gallery/shot-12.webp`, caption: 'Wildlife on the open plains' },
  { src: `${base}gallery/shot-13.webp`, caption: 'The old stone chapel', span: 'tall' },
  { src: `${base}gallery/shot-14.webp`, caption: 'Something watches in the dark' },
  { src: `${base}gallery/shot-15.webp`, caption: 'Azure forest over the farmlands', span: 'big' },
  { src: `${base}gallery/shot-16.webp`, caption: 'Rooftops of the trading quarter' },
  { src: `${base}gallery/shot-17.webp`, caption: 'Windmill village in the hills' },
  { src: `${base}gallery/shot-18.webp`, caption: 'A view across the valley', span: 'wide' },
  { src: `${base}gallery/shot-19.webp`, caption: 'Dusk over the rolling hills' },
  { src: `${base}gallery/shot-20.webp`, caption: 'Market square at the heart of town', span: 'big' },
  { src: `${base}gallery/shot-21.webp`, caption: 'Red-tiled streets' },
  { src: `${base}gallery/shot-22.webp`, caption: 'Sunset on the far coast', span: 'wide' },
  { src: `${base}gallery/shot-23.webp`, caption: 'Last light over the water' },
]

export default gallery
